import { takeLatest, take, put, call } from 'redux-saga/effects';

// actions
import { sendResetPasswordLink, setAPIInProgress } from 'store/actions/authActions';
import Api from 'api/auth';

export function* ensureSendResetPasswordLink({ payload }) {
  try {
    yield put({ type: setAPIInProgress.type, payload: true });
    yield call(Api.sendResetPasswordLink, { data: JSON.stringify(payload) });
    yield put({ type: sendResetPasswordLink.success });
    yield put({ type: setAPIInProgress.type, payload: false });
  } catch (err) {
    yield put({ type: setAPIInProgress.type, payload: false });
    yield put({
      type: sendResetPasswordLink.failure,
      err,
    });
  }
}

export function* watchSendingResetPasswordLink() {
  yield takeLatest(sendResetPasswordLink.type, ensureSendResetPasswordLink);
  yield take(sendResetPasswordLink.success);
}
